"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get COMPETENCY_LEVEL_GAPS () {
        return COMPETENCY_LEVEL_GAPS;
    },
    get CompetencyLevelGapSchema () {
        return CompetencyLevelGapSchema;
    }
});
const _zod = require("zod");
const COMPETENCY_LEVEL_GAPS = [
    "exceeds",
    "meets",
    "below",
    "no_level"
];
const CompetencyLevelGapSchema = _zod.z.enum(COMPETENCY_LEVEL_GAPS);
